import { ConsumerEntity } from '../consumer/consumer.entity';
import { Relation } from '../core/decorators/relation.decorator';
import { BaseEntity } from '../core/entities/base.entity';
import { Approval, MediaType } from '../core/types';
import { RelationRef } from '../core/types/entity-types';
import { SubjectEntity } from '../subject/subject.entity';

export class Medium {
  id!: string;
  mediaType!: MediaType;
  name!: string;
}

export class FunctionalHelpEntity extends BaseEntity {
  name!: string;
  subjectId!: string;
  consumerId!: string;
  exerciseKind!: string;

  exerciseSubKind?: string;
  markdownText?: string;
  markupText?: string;
  desktopAudio?: Medium | null;
  mobileAudio?: Medium | null;
  image?: Medium | null;
  approval?: Approval;
  active?: boolean;
  version?: number;
  updated?: Date;
  changedBy?: string;

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];
}
